import { createSlice } from '@reduxjs/toolkit'
import _ from 'lodash'

export const slice = createSlice({
  name: 'containers',
  initialState: {
    containersMap: {},
    isSet: false
  },
  reducers: {
    setLabelsAndBoxesMap: (state, action) => {
      const { labelsAndBoxesMap } = action.payload
      state.containersMap = _.cloneDeep(labelsAndBoxesMap)
      state.isSet = true
    }
  },
})

export const { setLabelsAndBoxesMap } = slice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectCount = state => state.counter.value

export default slice.reducer
